import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NavigationState {
  currentPage: string;
  lastVisitedPage: string;
}

const initialState: NavigationState = {
  currentPage: "/dashboard",
  lastVisitedPage: "/dashboard",
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload;
      state.lastVisitedPage = action.payload;
    },
    setLastVisitedPage: (state, action: PayloadAction<string>) => {
      state.lastVisitedPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logout", (state) => {
      state.currentPage = "/dashboard";
      state.lastVisitedPage = "/dashboard";
    });
  },
});

export const { setCurrentPage, setLastVisitedPage } = navigationSlice.actions;

export default navigationSlice.reducer;
